<script setup>
  import { computed, inject, onMounted } from 'vue'
  import { sortStandingEntries } from '@/services/utils'
  import StandingsTable from './StandingsTable.vue'

  const tournament = inject('tournament')
  const allEntries = inject('allEntries')
  const allTeams = inject('allTeams')

  const group_entries = defineModel('group_entries', { type: Array, default: () => [] })

  const teamsStandings = computed(() => {
    // cicla group entries e somma le stats per team
    const standings = {}

    for (const entry of group_entries.value ?? []) {
      const entryData = allEntries.value?.[String(entry.entry_id)]
      const teamId = entryData?.team_id
      if (!teamId) continue

      if (!standings[teamId]) {
        standings[teamId] = { team_id: teamId }
      }

      for (let [key, value] of Object.entries(entry)) {
        if (key === 'entry_id' || key === 'id' || key === 'group_id') continue
        const num = value === null || value === undefined || value === '' ? 0 : Number(value)
        if (!isNaN(num)) {
          standings[teamId][key] = (standings[teamId][key] ?? 0) + num
        }
      }
    }

    return sortStandingEntries(
      Object.values(standings),
      tournament.value,
      allTeams?.value ?? {}
    )
    
    
  })

</script>

<template>

  <StandingsTable
    :full-data-entries="teamsStandings"
    standingsType="teams"
  />

</template>